<template>
    <div style="display: flex; flex-direction: column; align-items: center; margin-bottom: 20px;">
        <div style="text-align: center; margin-bottom: 12px">
            <div :style="{fontSize: titleStyle ? titleStyle.fontSize : '', marginBottom: titleStyle ? titleStyle.marginBottom : ''}" style="font-weight: 700; line-height: 24px;">{{ title }}</div>
            <div v-html="subTitle" style="font-size: 14px; font-weight: 500; line-height: 24px;"></div> 
        </div>
        <div v-if="recommendMent !== ''" style="display: flex; align-items: center; gap: 6px; margin-bottom: 8px;">
            <div style="width: 4px; height: 4px; background-color: #210f03; border-radius: 50%;"></div>
            <div style="font-size: 12px; font-weight: 500;">{{ recommendMent }}</div>
        </div>
        <div :style="{marginTop: titleStyle ? '40px' : ''}">
            <div :class="titleStyle && each.contents === selectContents ? 'active_click' : 'un_active_click'" @click="clickContents(each.contents)" v-for="each, i in recommendReplyList" :key="i" style="width: 270px; font-weight: 500; margin-bottom: 8px; padding: 12px; border-radius: 12px; font-size: 14px; text-align: center; line-height: 24px;">
                {{ each.contents }}
            </div>
            <div @click="directInput" style="font-weight: 500; width: 270px; padding: 12px; border: 1px solid #d9d9d9; border-radius: 12px; font-size: 14px; text-align: center; line-height: 24px;">직접 입력하기...</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RecommendReplyList',
    props: {
        title: {
            type: String,
            default: ''
        },
        subTitle: {
            type: String,
            default: ''
        },
        recommendMent: {
            type: String,
            default: ''
        },
        recommendReplyList: {
            type: Array,
            default: () => {}
        },
        directInput: {
            type: Function,
            default: () => {}
        },
        clickContents: {
            type: Function,
            default: () => {}
        },
        titleStyle: {
            type: Object,
            default: () => {}
        },
        selectContents: {
            type: String,
            default: ''
        }
    },
}
</script>

<style scoped>
.active_click {
    border: 1px solid #210f03;
}

.un_active_click {
    border: 1px solid #d9d9d9;
}
</style>